"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Image_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Image"));

var MediaManagerImage_1 = require("@sportnet/ui/lib/MediaManagerImage");

var PictureFrame_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/PictureFrame"));

var polished_1 = require("polished");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var utilities_1 = require("../../utilities");

var linkClass = 'widget-sectionlist-link';
var StyledImage = styled_components_1["default"](Image_1["default"])(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background-size: cover !important;\n  width: 100%;\n  height: 100%;\n"], ["\n  background-size: cover !important;\n  width: 100%;\n  height: 100%;\n"])));
var NoImage = styled_components_1["default"].span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  position: absolute;\n  font-weight: bold;\n  top: 21%;\n  left: 0.335rem;\n  transform: translateY(-50%);\n  white-space: nowrap;\n  color: ", ";\n  opacity: 0.3;\n"], ["\n  font-size: ", ";\n  position: absolute;\n  font-weight: bold;\n  top: 21%;\n  left: 0.335rem;\n  transform: translateY(-50%);\n  white-space: nowrap;\n  color: ", ";\n  opacity: 0.3;\n"])), polished_1.rem(64), function (_a) {
  var theme = _a.theme;
  return polished_1.darken(0.2, theme.separatorColor);
});
var SectionBoxOverlay = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  background-image: linear-gradient(transparent, #000);\n  position: absolute;\n  bottom: 0;\n  height: 50%;\n  width: 100%;\n  overflow: hidden;\n"], ["\n  background-image: linear-gradient(transparent, #000);\n  position: absolute;\n  bottom: 0;\n  height: 50%;\n  width: 100%;\n  overflow: hidden;\n"])));
var Title = styled_components_1["default"].h3(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  color: #fff;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  margin: 10%;\n  font-family: 'Ubuntu', sans-serif;\n  font-size: ", ";\n"], ["\n  color: #fff;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  margin: 10%;\n  font-family: 'Ubuntu', sans-serif;\n  font-size: ", ";\n"])), polished_1.rem(16));
var SectionWrapper = styled_components_1["default"]('div')(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  .", " {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    border-radius: ", ";\n    background: ", ";\n    margin: 0;\n\n    & ", " {\n      transition: all 300ms;\n    }\n    &:hover ", " {\n      transform: scale(1.1);\n    }\n  }\n"], ["\n  display: flex;\n  .", " {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    border-radius: ", ";\n    background: ", ";\n    margin: 0;\n\n    & ", " {\n      transition: all 300ms;\n    }\n    &:hover ", " {\n      transform: scale(1.1);\n    }\n  }\n"])), linkClass, function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
}, function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, StyledImage, StyledImage);

function WidgetSectionList(props) {
  var hideSectionTitles = props.hideSectionTitles,
      section = props.section,
      renderLink = props.renderLink;
  return react_1["default"].createElement(SectionWrapper, {
    key: section._id
  }, renderLink({
    type: utilities_1.WIDGET_LINK_TYPE.SECTION_DETAIL,
    payload: section,
    section: section,
    linkProps: {
      className: linkClass,
      children: react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(PictureFrame_1["default"], {
        width: 4,
        height: 3
      }, section.picture ? react_1["default"].createElement(StyledImage, {
        alt: section.name,
        height: "100%",
        src: MediaManagerImage_1.getMediaManagerUrl(section.picture, 360, 270, 'media')
      }) : react_1["default"].createElement(NoImage, null, section.name)), react_1["default"].createElement(SectionBoxOverlay, null, !hideSectionTitles && react_1["default"].createElement(Title, null, section.name)))
    }
  }));
}

WidgetSectionList.propTypes = {
  hideSectionTitles: prop_types_1["default"].bool.isRequired,
  section: prop_types_1["default"].shape({}).isRequired,
  renderLink: prop_types_1["default"].func.isRequired
};
exports["default"] = WidgetSectionList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;